import { useEffect, useState } from "react";
import usePost from "../../../hooks/usePost";
import { PRODUCTCATEGORY } from "../../../routes/routes_name";
import { useLocation } from "react-router-dom";
import usePut from "../../../hooks/usePut";
import { propTypes } from "react-bootstrap/esm/Image";

const UseFormProductCategory = (props) => {
  const { isLoading, error, isSuccess, navigate, handlePost } = usePost();
  const {
    isLoading: isLoadingPut,
    error: errorPut,
    isSuccess: isSuccessPut,
    navigate: navigatePut,
    handlePut,
  } = usePut();

  const location = useLocation();
  const [form, setForm] = useState({});
  const [isOn, setIsOn] = useState(false);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [selectedAttachments, setSelectedAttachments] = useState([]);
  const formData = new FormData();
  useEffect(() => {}, [isLoading]);

  useEffect(() => {
    if (props.type === "post") {
      setForm({
        code: "",
        name: "",
        category: "",
        description: "",
        thumbnail: null,
        measuring_description: "",
        attachments: [],
        status: "inaktif",
      });
    } else {
      handleSwitch(location.state.status);
      setIsOn(location.state.status === "aktif");
      
      // Handle thumbnail from backend (object with url)
      const thumbnailPreview = location.state.thumbnail?.thumbnail_url || location.state.thumbnail?.url || null;
      
      setForm({
        _id: location.state._id,
        code: location.state.code,
        name: location.state.name || "",
        category: location.state.category,
        description: location.state.description,
        thumbnail: thumbnailPreview,
        measuring_description: location.state.measuring_description || "",
        attachments: location.state.attachments || [],
        status: location.state.status,
      });
    }
  }, []);

  const handleSwitch = (props) => {
    if (props !== "") {
      setForm({
        ...form,
        ["status"]: props,
      });
      setIsOn(props === "aktif");
    } else {
      setForm({
        ...form,
        ["status"]: !isOn ? "aktif" : "inaktif",
      });
      setIsOn(!isOn);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const submitData = new FormData();
    
    submitData.append("code", form["code"]);
    submitData.append("name", form["name"] || "");
    submitData.append("category", form["category"]);
    submitData.append("description", form["description"]);
    submitData.append("measuring_description", form["measuring_description"] || "");
    submitData.append("status", form["status"] ?? "inaktif");
    
    // Append thumbnail file if selected
    if (selectedThumbnail) {
      submitData.append("thumbnail", selectedThumbnail);
    }
    
    // Append multiple attachment files
    if (selectedAttachments && selectedAttachments.length > 0) {
      selectedAttachments.forEach((file) => {
        submitData.append("attachments", file);
      });
    }
    
    let params = {
      url: "/v1/product-category/create-products",
      form: submitData,
      navigation: PRODUCTCATEGORY,
      titleSuccess: "Saved!",
      descSuccess: "Product Category data has been successfully saved.",
      type: "multipart/form-data",
    };

    if (props.type === "post") {
      handlePost(params);
    } else {
      params.titleSuccess = "Edited!";
      params.descSuccess = "Category Product data has been successfully edited.";
      params.url = `/v1/product-category/${form["_id"]}`;
      handlePut(params);
    }
  };

  const handleImageChange = (img, id) => {
    if (id === "thumbnail") {
      setSelectedThumbnail(img);
      if (img) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setForm({ ...form, thumbnail: reader.result });
        };
        reader.readAsDataURL(img);
      }
    } else if (id === "attachments") {
      // Handle multiple files
      const files = img.target ? Array.from(img.target.files) : (Array.isArray(img) ? img : [img]);
      setSelectedAttachments(files);
      
      // Create preview URLs
      const previews = [];
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          previews.push({ url: reader.result, name: file.name });
          if (previews.length === files.length) {
            setForm({ ...form, attachments: previews });
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  const handleChange = (props) => {
    const { id, value } = props.target;

    setForm({
      ...form,
      [id]: value,
    });
  };

  const removePreview = () => {
    const newSetForm = { ...form };
    newSetForm.thumbnail = null;
    setForm(newSetForm);
  };

  return {
    isLoading,
    isLoadingPut,
    form,
    formData,
    isOn,
    removePreview,
    handleSwitch,
    handleChange,
    handleImageChange,
    handleSubmit,
  };
};

export default UseFormProductCategory;
